/**
 * @file video-player.js
 *
 * Fully Reusable Drupal behavior for background video players and reveal animations.
 * Works across any component by extracting selectors via dynamic configuration data attributes.
 */

(function (Drupal, once) {
  'use strict';

  if (!Drupal || !once) {
    console.warn('Drupal or once library is not available');
    return;
  }

  /**
   * Helper utility to convert duration strings (e.g., "MM:SS" or "HH:MM:SS") to numeric seconds.
   */
  function parseDurationSeconds(value) {
    if (value === null || value === undefined || value === '') {
      return 0;
    }
    if (typeof value === 'number') {
      return value;
    }
    var trimmed = String(value).trim();
    if (!trimmed) {
      return 0;
    }
    if (/^\d+(\.\d+)?$/.test(trimmed)) {
      return parseFloat(trimmed);
    }
    var timeParts = trimmed.split(':').map(function (part) {
      return Number(part);
    });

    if (timeParts.length === 3) {
      return (timeParts[0] * 3600) + (timeParts[1] * 60) + timeParts[2];
    }
    if (timeParts.length === 2) {
      return (timeParts[0] * 60) + timeParts[1];
    }
    return parseFloat(trimmed) || 0;
  }

  Drupal.behaviors.universalVideoPlayer = {
    attach: function (context) {
      // 1. Core Video Management Loop
      // Tracks any element initializing with the global hook attribute
      const playerElements = once('hero-video', '[data-hero-video]', context);

      playerElements.forEach(function (playerContainer) {
       
        // Query components relative to the scoped instance wrapper
        var video = playerContainer.querySelector('.video_banner');
        var playbackBtn = playerContainer.querySelector('.video_control__btn--playback');
        var volumeBtn = playerContainer.querySelector('.video_control__btn--volume');

        if (!video) {
          return;
        }

        /**
         * Update Play/Pause UI States
         */
        function updatePlaybackUI() {
          if (!playbackBtn) {
            return;
          }
          
          var playIcon = playbackBtn.querySelector('.video_control__icon--play');
          var pauseIcon = playbackBtn.querySelector('.video_control__icon--pause');

          if (video.paused) {
            playbackBtn.classList.add('is-paused');
            playbackBtn.setAttribute('aria-label', 'Play video');
            playbackBtn.setAttribute('aria-pressed', 'false');

            if (playIcon) {
              playIcon.style.opacity = '1';
              playIcon.style.pointerEvents = 'auto';
              playIcon.style.cursor = 'pointer';
            }
            if (pauseIcon) {
              pauseIcon.style.opacity = '0.5';
              pauseIcon.style.pointerEvents = 'none';
              pauseIcon.style.cursor = 'default';
            }
          } else {
            playbackBtn.classList.remove('is-paused');
            playbackBtn.setAttribute('aria-label', 'Pause video');
            playbackBtn.setAttribute('aria-pressed', 'true');

            if (playIcon) {
              playIcon.style.opacity = '0.5';
              playIcon.style.pointerEvents = 'none';
              playIcon.style.cursor = 'default';
            }
            if (pauseIcon) {
              pauseIcon.style.opacity = '1';
              pauseIcon.style.pointerEvents = 'auto';
              pauseIcon.style.cursor = 'pointer';
            }
          }
        }

        // Reduced Motion
        var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (prefersReducedMotion) {
          video.pause();
        }

        /**
         * Dynamic Configured Loop
         */
        function configureVideoLoop() {
          if (!video.hasAttribute('data-loop') || !isFinite(video.duration)) {
            return;
          }

          var datasetThreshold = playerContainer.dataset.loopDurationThreshold;
          var threshold = parseDurationSeconds(datasetThreshold || '5');

          if (video.duration > threshold) {
            video.loop = true;
            return;
          }

          video.loop = false;
          var playCount = 0;

          video.addEventListener('ended', function () {
            playCount += 1;
            if (playCount < 8) {
              video.currentTime = 0;
              video.play();
            }
          });
        }

        if (video.readyState >= 1) {
          configureVideoLoop();
        } else {
          video.addEventListener('loadedmetadata', configureVideoLoop, { once: true });
        }

        // Playback Interactions
        if (playbackBtn) {
          var playIcon = playbackBtn.querySelector('.video_control__icon--play');
          var pauseIcon = playbackBtn.querySelector('.video_control__icon--pause');

          if (playIcon) {
            playIcon.addEventListener('click', function (e) {
              e.preventDefault();
              e.stopPropagation();
              if (video.paused) { video.play(); }
            });
          }

          if (pauseIcon) {
            pauseIcon.addEventListener('click', function (e) {
              e.preventDefault();
              e.stopPropagation();
              if (!video.paused) { video.pause(); }
            });
          }

          video.addEventListener('play', updatePlaybackUI);
          video.addEventListener('pause', updatePlaybackUI);
          updatePlaybackUI();
        }

        // Volume Interactions
        if (volumeBtn) {
          video.muted = true;
          volumeBtn.addEventListener('click', function () {
            if (video.muted) {
              video.muted = false;
              volumeBtn.classList.add('is-unmuted');
              volumeBtn.setAttribute('aria-label', 'Mute video');
              volumeBtn.setAttribute('aria-pressed', 'true');
            } else {
              video.muted = true;
              volumeBtn.classList.remove('is-unmuted');
              volumeBtn.setAttribute('aria-label', 'Unmute video');
              volumeBtn.setAttribute('aria-pressed', 'false');
            }
          });
        }
      });

    }
  };

})(Drupal, once);



